// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RuVrf","question":"styles_question__1Cd8O","description":"styles_description__bco4s"};